import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/theme.css'
import Login from "@/components/Login";
import BrowserIssues from "@/components/browser/Issues";
import BrowserNotifications from "@/components/browser/Notifications";
import {
    Button,
    Calendar,
    Cell,
    CellGroup,
    Col,
    DatetimePicker,
    Divider,
    Field,
    Lazyload,
    NavBar,
    Picker,
    Popup,
    Row,
    Swipe,
    SwipeItem,
    Tabbar,
    TabbarItem,
    Toast,
    Uploader
} from 'vant';
import CMS from "@/components/browser/CMS";
import BrowserEmployees from "@/components/browser/Employees";
import BrowserOrganizationStructure from "@/components/browser/OrganizationStructure";
import BrowserSlideshow from "@/components/browser/Slideshow";
import BrowserIssueRank from "@/components/browser/IssueRank";
import BrowserIssueStats from "@/components/browser/IssueStats";
import BrowserProfile from "@/components/browser/Profile";
import BrowserCompanyList from "@/components/browser/CompanyList";
import BrowserEmployeeList from "@/components/browser/EmployeeList";
import Axios from 'axios';
import './utils/refreshToken';
import { initializeTheme } from './utils/theme';
import { initializeI18n } from './i18n';


Vue.use(Divider);
Vue.use(Calendar);
Vue.use(Col);
Vue.use(Row);
Vue.use(DatetimePicker);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(Field);
Vue.use(Uploader);
Vue.use(Lazyload);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(VueRouter)
Vue.use(ElementUI)
Vue.use(NavBar);
Vue.use(Toast);
Vue.use(Button)

Vue.config.productionTip = false
initializeTheme();
initializeI18n();

const accessToken = localStorage.getItem('accessToken');
if (accessToken) {
    Axios.defaults.headers.common['Authorization'] = 'Bearer ' + accessToken;
}

const routes = [
    {path: '/', component: Login},
    {path: '/login', component: Login},
    {
        path: '/cms', component: CMS, redirect: '/cms/browser/issues', children: [
            {path: '/browser/issues', component: BrowserIssues},
            {path: '/browser/employees', component: BrowserEmployees},
            {path: '/browser/organization-structure', component: BrowserOrganizationStructure},
            {path: '/browser/slideshow', component: BrowserSlideshow},
            {path: '/browser/notifications', component: BrowserNotifications},
            {path: '/browser/profile', component: BrowserProfile},
            {path: '/browser/issue-rank', component: BrowserIssueRank},
            {path: '/browser/issue-stats', component: BrowserIssueStats},
            {path: '/browser/employee-list', component: BrowserEmployeeList},
            {path: '/browser/companies', component: BrowserCompanyList},
        ]
    },
    {path: '/browser/issues', component: BrowserIssues},
    {path: '/browser/notifications', component: BrowserNotifications},
    {path: '/browser/profile', component: BrowserProfile},
    {path: '/browser/issue-rank', component: BrowserIssueRank},
    {path: '/browser/issue-stats', component: BrowserIssueStats},
    {path: '/browser/employee-list', component: BrowserEmployeeList},
    {path: '/browser/companies', component: BrowserCompanyList},
];

const router = new VueRouter({
    routes
})

new Vue({
    render: h => h(App),
    router
}).$mount('#app')
